export default [
    {
        "href": "/specialprofiles",
        "thumbnail": require("../assets/images/waggonprofile.jpg"),
        "titles":
            {
                "fr": [
                    "Profilés spéciaux"
                ],
                "en": [
                    "Special profiles"
                ]
            },
        "class": "col-xs-10 col-lg-5 col-sm-5"
    },
    {
        "href": "/architecture-constructions/realisations",
        "thumbnail": require("../assets/images/industry-architecture.jpg"),
        "titles":
            {
                "fr": [
                    "Architecture et constructions"
                ],
                "en": [
                    "Architecture and constructions"
                ]
            },
        "class": "col-xs-10 col-lg-5 col-sm-5"

    },
    {
        "href": "/freeforge",
        "thumbnail": require("../assets/images/forgingdescendue.jpg"),
        "titles":
            {
                "fr": [
                    "Forge Libre",
                ],
                "en": [
                    "Open die forging",
                ]
            },
        "class": "col-xs-10 col-lg-5 col-sm-5"
    },
    {
        "href": "/colddrawn/bollinghaus",
        "thumbnail": require("../assets/images/boellproduction.jpg"),
        "titles":
            {
                "fr": [
                    "Plats, carrés, hexagones inox"
                ],
                "en": [
                    "Stainless steel flats, squares, hexagons"
                ]
            },
        "class": "col-xs-10 col-lg-5 col-sm-5"
    },

]